module.exports = __webpack_public_path__ + "img/QR-7Eleven.b2578fbb.png";